import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Importa useLocation
import Swal from 'sweetalert2';
import { TranslatorContext } from "../../context/Translator";
import { useDolar } from "../../context/DolarContext";
import { Dropdown, Tab, Tabs, Form, Row, Col } from "react-bootstrap";
import users from "../../assets/data/users.json";
import { AnchorComponent, ButtonComponent } from "../elements";
import Modal from 'react-bootstrap/Modal';
import ModalSeleccionarColumnasReporte from "../modals/ModalSeleccionarColumnasReporte";
import {getApoderdosGiras, 
        getAlumnosGira, 
        getAlumno,
        getAlumnosEliminadosGira, 
        enviarListadoapoderados,
        cargarNominaAlumnos, 
        eliminarAlumnoGira, 
        agregareliminarAlumnoGira,
        cuotasAlumno,
        agregarAlumnoGira,
        descargarPlanillaAduana,
        descargarPlanillaInterna, 
        descargarLogAcceso,  
        registrarPagosFuncionario,
        enviarDocumentos,
        getDocumentosGira,
        editarAlumnoGira,
        obtenerDocumentosApoderado,
        descargarDocumentoApoderado,
        obtenerSolicitudReembolso,
        aprobarReembolso,
        rechazarReembolso,
        descargarArchivoReembolso,
        obtenerResponsableGira,
        cambiarResponsableGira,
        descargarReporteAlumnosColumnas
        } from "../../api/giras.ts";
import {
  cargarDocumentoCoordinador,
  obtenerDocumentosCoordinador,
  descargarDocumentoCoordinador,
  actualizarDocumentoCoordinador,
  eliminarDocumentoCoordinador
} from "../../api/documentosCoordinador.api.ts";
import {getTipoPasajeros, descargarArchivo, getReporteMenoresEdad, tipoAlimentacion, tipoSangre} from "../../api/mantenedores.ts";
import {obtenerContactosEmergencia} from "../../api/contactoEmergencia.api.ts";
import {formatRUT} from "../../utils/Rut.ts";      
import {SingleFileUploadButton} from "../upload/SingleFileUploadButton.tsx";

// Constantes de tipos de archivo (fuera del componente para evitar recreación)
const acceptTypesDocumentoCoordinador = {
    "application/pdf": [".pdf"]
};

export default function ListadoUsuariosGiraComponent({gira}) {

    
    const { t } = useContext(TranslatorContext)
    const { dolar, loading: dolarLoading, error: dolarError } = useDolar();
    const [alertModal, setAlertModal] = useState(false);
    
    // Función helper para formatear moneda según el tipo de gira
    const formatearMoneda = (monto) => {
        if (!monto) return '0';
        
        // Si la gira es en dólares, mostrar conversión
        if (gira?.gir_pagodolares?.data[0]) {
            const montoEnDolares = monto;
            return `US$${montoEnDolares.toFixed(2)}`;
        } else {
            return `$${monto.toLocaleString('es-CL')}`;
        }
    };
    
    // Función para obtener valor del dólar para cálculos
    const obtenerValorDolar = () => {
        return dolar || 1000; // Valor por defecto si no está disponible
    };

    // Función para formatear fecha de DD/MM/YYYY a YYYY-MM-DD
    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        if (dateString.includes('-')) return dateString;
        const [day, month, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    // Función para formatear fecha de YYYY-MM-DD a DD/MM/YYYY
    const formatDateForSave = (dateString) => {
        if (!dateString) return "";
        if (dateString.includes('/')) return dateString;
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };
    
    const [alertModalAgregar, setAlertModalAgregar] = useState(false);
    const [alertModalDetalle, setAlertModalDetalle] = useState(false);
    const [alertModalEliminar, setAlertModalEliminar] = useState(false);
    const [idgira, setIdGira] = useState("");
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showUploadModalDoc, setShowUploadModalDoc] = useState(false);
    const [showUploadModalNomina, setShowUploadModalNomina] = useState(false);
    const [showAddPassengerModal, setShowAddPassengerModal] = useState(false);
    const [showModalSeleccionarColumnas, setShowModalSeleccionarColumnas] = useState(false);
    const [selectedAlumno, setSelectedAlumno] = useState(null);
    const [file, setFile] = useState("");
    const [fileDoc, setFileDoc] = useState("");
    const [fileNomina, setFileNomina] = useState("");
    const [alumnoSelecionado, setAlumnoSelecionado] = useState(null);

     const [selectedCuotas, setSelectedCuotas] = useState([]);
     const [totalMonto, setTotalMonto] = useState(0);
     const [valorGiraAlumno, setValorGiraAlumno] = useState(0);
     const [valorAbono, setValorAbono] = useState(0);

    const [multasModificadas, setMultasModificadas] = useState({});
    const [detalleModificadas, setDetalleModificadas] = useState({});

    const [errors, setErrors] = useState({});

    const [passengerData, setPassengerData] = useState({
        nombres: '',
        apellidos: '',
        rut: '',
        calidad:'',
        idcalidad: '',
        fnacimiento: '',
        sexo: '',
        alergia: '',
        nacionalidad: '',
        edad: '',
        alu_enfermedad: '',
        idalimentacion: '',
        idsangre: '',
        alu_tipo_documento: '',
        alu_fecha_vencimiento_documento: '',

    });
    const [cuotasAlumnoGira, setCuotasAlumnoGira] = useState([]);
    const [apoderados, setApoderados] = useState([]);
    const [apoderado, setApoderado] = useState([]);
    const [alumnos, setAlumnos] = useState([]); 
    const [tipoPasajeros, setTipoPasajeros] = useState([]);
    const [alumnosEliminados, setAlumnosEliminados] = useState([]);
    const [documentosGira, setDocumentosGira] = useState([]);
    const [documentosAlumno, setDocumentosAlumno] = useState([]);
    const [reembolsoData, setReembolsoData] = useState(null);
    const [showReembolsoModal, setShowReembolsoModal] = useState(false);
    const [reembolsoAccion, setReembolsoAccion] = useState(null); // 'aprobar' o 'rechazar'
    const [reembolsoMonto, setReembolsoMonto] = useState('');
    const [reembolsoComentario, setReembolsoComentario] = useState('');
    const [contactosEmergencia, setContactosEmergencia] = useState([]);
    const [responsableAlumno, setResponsableAlumno] = useState(null);
    const [tipoAlimentacionData, setTipoAlimentacionData] = useState([
        { id: 1, nombre: 'Sin restricción' },
        { id: 2, nombre: 'Vegetariano' },
        { id: 3, nombre: 'Vegano' },
        { id: 4, nombre: 'Celiaco' },
        { id: 5, nombre: 'Intolerante a la lactosa' }
    ]);
    const [tipoSangreData, setTipoSangreData] = useState([]);

    // Estados para responsable de gira
    const [responsableActual, setResponsableActual] = useState(null);
    const [showResponsableModal, setShowResponsableModal] = useState(false);

    // Estados para búsqueda de pasajeros
    const [busquedaPasajeros, setBusquedaPasajeros] = useState("");
    const [busquedaNuevosPasajeros, setBusquedaNuevosPasajeros] = useState("");

    // Función para filtrar pasajeros
    const filtrarAlumnos = (alumnosList, termino) => {
        if (!termino.trim()) {
            return alumnosList;
        }
        const termLower = termino.toLowerCase();
        return alumnosList.filter(item => 
            (item.alu_nombres && String(item.alu_nombres).toLowerCase().includes(termLower)) ||
            (item.alu_apellidos && String(item.alu_apellidos).toLowerCase().includes(termLower)) ||
            (item.alu_rut && String(item.alu_rut).toLowerCase().includes(termLower)) ||
            (item.usu_nombre && String(item.usu_nombre).toLowerCase().includes(termLower)) ||
            (item.usu_apellido && String(item.usu_apellido).toLowerCase().includes(termLower)) ||
            (item.usu_rut && String(item.usu_rut).toLowerCase().includes(termLower))
        );
    };
    const [apoSeleccionadoResponsable, setApoSeleccionadoResponsable] = useState(null);

    const acceptTypes = {
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
          ".xlsx"
        ]
        // Agrega más tipos de archivo según tus necesidades
      };

    const acceptTypesDoc = {
        "application/pdf": [".pdf"]
        // Agrega más tipos de archivo según tus necesidades
      };
    
    // ==================== Estados para Documentos de Coordinadores ====================
    const [documentosCoordinador, setDocumentosCoordinador] = useState([]);
    const [showUploadDocumentoCoordinador, setShowUploadDocumentoCoordinador] = useState(false);
    const [fileDocumentoCoordinador, setFileDocumentoCoordinador] = useState("");
    const [docTipoCoordinador, setDocTipoCoordinador] = useState("");
    const [docDescripcionCoordinador, setDocDescripcionCoordinador] = useState("");
    const [loadingDocumentos, setLoadingDocumentos] = useState(false);

    const handleShowUploadModal = () => setShowUploadModal(true);
    const handleShowUploadDocModal = () => setShowUploadModalDoc(true);
    const handleShowUploadNominaModal = () => setShowUploadModalNomina(true);
    const handleCloseUploadModal = () => setShowUploadModal(false);
    const handleCloseUploadModalDoc = () => setShowUploadModalDoc(false);
    const handleCloseUploadNominaModal = () => setShowUploadModalNomina(false);
    const handleShowAddPassengerModal = () => setShowAddPassengerModal(true);
    const handleCloseAddPassengerModal = () => setShowAddPassengerModal(false);
    
    const handleShowUploadDocumentoCoordinador = () => setShowUploadDocumentoCoordinador(true);
    const handleCloseUploadDocumentoCoordinador = () => {
        setShowUploadDocumentoCoordinador(false);
        setFileDocumentoCoordinador("");
        setDocTipoCoordinador("");
        setDocDescripcionCoordinador("");
    };
    
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
        const giraId = params.get('gira'); // Obtén el valor del parámetro 'gira'
        setIdGira(giraId);
        const fetchTablaApoderados = async () => {  
            const res = await getApoderdosGiras(giraId);
            setApoderados(res);
        } 

        const fetchTablaAlumnos = async () => {
            const res = await getAlumnosGira(giraId);
            setAlumnos(res);
        }


        const fetchTablaAlumnosEliminados = async () => {
            const res = await getAlumnosEliminadosGira(giraId);
            setAlumnosEliminados(res);
        }


        const fetchTablaDocumento = async () => {
            const res = await getDocumentosGira(giraId);
            setDocumentosGira(res);
        }

        const fetchDocumentosCoordinador = async () => {
            const res = await obtenerDocumentosCoordinador(giraId);
            if (!res.error) {
                setDocumentosCoordinador(res.data);
            }
        }


        const fetchTipoPasajeros = async () => {
            const res = await getTipoPasajeros();
          
            setTipoPasajeros(res.data);
        }

        const fetchResponsableGira = async () => {
            const res = await obtenerResponsableGira(giraId);
            if (!res.error && res.responsable) {
                setResponsableActual(res.responsable);
            }
        }

        
        fetchTablaApoderados();
        fetchTablaAlumnos();
        fetchTablaAlumnosEliminados();
        fetchResponsableGira();
        fetchTipoPasajeros();
        fetchTablaDocumento();
        fetchDocumentosCoordinador();
                   
    }, []);
    

    const fetchTablaApoderados = async (giraId) => {  
        const res = await getApoderdosGiras(giraId);
        setApoderados(res);
    } 

    const fetchTablaAlumnos = async (giraId) => {
        const res = await getAlumnosGira(giraId);
        setAlumnos(res);
    }

    const fetchTablaAlumnosEliminados = async (giraId) => {
        const res = await getAlumnosEliminadosGira(giraId);
        setAlumnosEliminados(res);
    }

    const handleFileUpload = (e) => {
        console.log(e);
        if (e != null) setFile(e.id);
        else setFile("");
    };

    const handleFileUploadDoc = (e) => {
        console.log(e);
        if (e != null) setFileDoc(e.id);
        else setFileDoc("");
    };

    const handleFileUploadNomina = (e) => {
        console.log(e);
        if (e != null) setFileNomina(e.id);
        else setFileNomina("");
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setPassengerData({
            ...passengerData,
            [name]: value
        });
    };

    const handleAddPassenger = () => {
        // Aquí puedes manejar la lógica para agregar el pasajero
       
        handleCloseAddPassengerModal();
    };

    const validateForm = () => {
        const newErrors = {};
    
       
    
        if (file === "") {
          newErrors.file = "Debe seleccionar un archivo";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };


      const validateFormDoc = () => {
        const newErrors = {};
    
       
    
        if (fileDoc === "") {
          newErrors.file = "Debe seleccionar un archivo";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

      const validateFormNomina = () => {
        const newErrors = {};
    
        if (fileNomina === "") {
          newErrors.file = "Debe seleccionar un archivo";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

    const handleCargarData = (e) => {
        console.log(file);
        if (validateForm()) {
          e.preventDefault();
    
          Swal.fire({
            title: "Cargando apoderados",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
         
            enviarListadoapoderados(file, idgira).then((res) => {
              Swal.close();
              if (res.error === false) {
                
                Swal.fire({
                  icon: "success",
                  text: res.msg
                });
                window.location.reload();
                fetchTablaApoderados(idgira);
                fetchTablaAlumnos(idgira);
                fetchTablaAlumnosEliminados(idgira);
                
              } else {
                Swal.fire({
                  icon: "error",
                  text: res.msg
                });
              }
            });
        
        }
      };

       const handleCargarDataDoc = (e) => {
       
        if (validateFormDoc()) {
          e.preventDefault();
    
          Swal.fire({
            title: "Cargando documento",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
         
            enviarDocumentos(fileDoc, idgira).then((res) => {
              Swal.close();
              if (res.error === false) {
                
                Swal.fire({
                    icon: "success",
                    text: "Operación exitosa."
                    }).then(() => {
                    window.location.reload();
                    });

                setFileDoc("");
                //navigateTo(ROUTES.CARGAINDICADORES);
              } else {
                Swal.fire({
                  icon: "error",
                  text: res.msg
                });
              }
            });
        
        }
      };

      const handleCargarNomina = (e) => {
        if (validateFormNomina()) {
          e.preventDefault();
    
          Swal.fire({
            title: "Cargando nómina de alumnos",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
          cargarNominaAlumnos(fileNomina, idgira).then((res) => {
            Swal.close();
            if (res.error === false) {
              Swal.fire({
                icon: "success",
                text: res.msg
              });
              setFileNomina("");
              handleCloseUploadNominaModal();
              window.location.reload();
              fetchTablaAlumnos(idgira);
            } else {
              Swal.fire({
                icon: "error",
                text: res.msg
              });
            }
          });
        }
      };

      
          const handleDownload = async (fileId, fileName) => {
                  try {
                    const response = await descargarArchivo(fileId, 'pdf');
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); // Nombre del archivo
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                  } catch (error) {
                    Swal.fire({
                      icon: 'error',
                      text: 'Error al descargar el archivo'
                    });
                  }
          };

    const handleCambiarResponsable = async () => {
        if (!apoSeleccionadoResponsable) {
            Swal.fire({
                icon: "warning",
                title: "Selecciona un Responsable",
                text: "Por favor selecciona un apoderado para asignar como responsable"
            });
            return;
        }

        // Si ya hay responsable, mostrar confirmación
        if (responsableActual && responsableActual.usu_id !== apoSeleccionadoResponsable.usu_id) {
            Swal.fire({
                title: "¿Cambiar Responsable?",
                html: `<p>Deshabilitarás a <strong>${responsableActual.usu_nombre} ${responsableActual.usu_apellido}</strong> como responsable</p>
                       <p>Habilitarás a <strong>${apoSeleccionadoResponsable.usu_nombre} ${apoSeleccionadoResponsable.usu_apellido}</strong> como responsable</p>`,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, cambiar",
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    procederCambioResponsable();
                }
            });
        } else {
            procederCambioResponsable();
        }
    };

    const procederCambioResponsable = async () => {
        Swal.fire({
            title: "Actualizando Responsable",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const resultado = await cambiarResponsableGira(idgira, apoSeleccionadoResponsable.usu_id);
        
        Swal.close();

        if (!resultado.error) {
            Swal.fire({
                icon: "success",
                title: "Responsable Actualizado",
                html: `<p><strong>${apoSeleccionadoResponsable.usu_nombre} ${apoSeleccionadoResponsable.usu_apellido}</strong> es ahora el responsable de la gira</p>`,
                confirmButtonText: "Aceptar"
            }).then(() => {
                setResponsableActual(resultado.responsable);
                setShowResponsableModal(false);
                setApoSeleccionadoResponsable(null);
                // Recargar apoderados para actualizar UI
                fetchTablaApoderados(idgira);
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: resultado.msg || "Error al actualizar responsable"
            });
        }
    };

    const handleDeleteAlumno = () => {
        if (selectedAlumno) {
            /*setAlumnos(alumnos.filter(alumno => alumno !== selectedAlumno));
            setAlertModal(false);
            Swal.fire({
                icon: "success",
                text: "Alumno eliminado correctamente."
            });*/
            setAlertModalEliminar(false);
            Swal.fire({
                title: "Eliminando Alumno",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
             
              eliminarAlumnoGira(selectedAlumno.alu_id, idgira).then((res) => {
                  Swal.close();
                  if (res.error === false) {
                  
                        fetchTablaApoderados(idgira);
                        fetchTablaAlumnos(idgira);
                        fetchTablaAlumnosEliminados(idgira);
                
                    Swal.fire({
                      icon: "success",
                      text: "Alumno eliminado de la Gira."
                    });
                    //navigateTo(ROUTES.CARGAINDICADORES);
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: res.msg
                    });
                  }
                });
        }
    };

    const handleSubirPasajero = (alumno) => {
        Swal.fire({
            title: "¿Subir Pasajero?",
            text: `¿Está seguro de que desea subir a ${alumno.alu_nombres} ${alumno.alu_apellidos} a la gira?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, subir",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Subiendo Pasajero",
                    text: "Por favor, espere...",
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    }
                });
                
                agregareliminarAlumnoGira(alumno.alu_id, idgira, alumno).then((res) => {
                    Swal.close();
                    if (res.error === false) {
                        fetchTablaApoderados(idgira);
                        fetchTablaAlumnos(idgira);
                        fetchTablaAlumnosEliminados(idgira);
                        
                        Swal.fire({
                            icon: "success",
                            text: "Pasajero subido correctamente a la Gira."
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: res.msg || "Error al subir el pasajero"
                        });
                    }
                });
            }
        });
    };

    const handleAgregarAlumno = () => {
        if(apoderado){
            setAlertModalAgregar(false);
            Swal.fire({
                title: "Agregando Alumno",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
             
              agregarAlumnoGira(apoderado.apo_id, idgira, passengerData).then((res) => {
                  Swal.close();
                  if (res.error === false) {
                  
                        fetchTablaApoderados(idgira);
                        fetchTablaAlumnos(idgira);
                        fetchTablaAlumnosEliminados(idgira);

                    Swal.fire({
                      icon: "success",
                      text: "Alumno agregado a la Gira."
                    });
                    //navigateTo(ROUTES.CARGAINDICADORES);
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: res.msg
                    });
                  }
                });
        }
    };

    const handleDescargaAduana = () => {
        Swal.fire({
            title: "Descargando Planilla Aduana",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          descargarPlanillaAduana(idgira).then((res) => {
              Swal.close();
              if (res.error === true) {
                Swal.fire({
                  icon: 'success',
                  text: 'Reporte generado correctamente.'
                })
                //navigateTo(ROUTES.USUARIOS);
              }else{
                const url = window.URL.createObjectURL(res);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'planila_aduana.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                //  window.URL.revokeObjectURL(url);
              }
            });     
    }

    const handleDescargaLogAcceso = () => {
        Swal.fire({
            title: "Descargando Planilla de Log de Acceso",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          descargarLogAcceso(idgira).then((res) => {
              Swal.close();
              if (res.error === true) {
                Swal.fire({
                  icon: 'success',
                  text: 'Reporte generado correctamente.'
                })
                //navigateTo(ROUTES.USUARIOS);
              }else{
                const url = window.URL.createObjectURL(res);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'reporte_log_acceso.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                //  window.URL.revokeObjectURL(url);
              }
            });     
    }

    // Función para formatear fecha en formato dd/mm/yyyy HH:mm
    const formatearFecha = (fecha) => {
      if (!fecha) return '';
      const date = new Date(fecha);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const anio = date.getFullYear();
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
      return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
    };
    
    const handleDescargaInterna = () => {
        Swal.fire({
            title: "Descargando Planilla Interna",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
          descargarPlanillaInterna(idgira).then((res) => {
              Swal.close();
              if (res.error === true) {
                Swal.fire({
                  icon: 'success',
                  text: 'Reporte generado correctamente.'
                })
                //navigateTo(ROUTES.USUARIOS);
              }else{
                const url = window.URL.createObjectURL(res);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'planila_interna.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                //  window.URL.revokeObjectURL(url);
              }
            });     
    }

    const handleDescargaMenoresEdad = () => {
        
        
        Swal.fire({
            title: 'Generando reporte...',
            text: 'Por favor espere',
            icon: 'info',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
        
        getReporteMenoresEdad(idgira).then((res) => {
            Swal.close();
            
            if (res.error === true) {
                Swal.fire({
                    icon: 'error',
                    text: 'Error al generar el reporte de menores de edad.'
                });
            } else {
                Swal.fire({
                    icon: 'success',
                    text: 'Reporte de menores de edad generado correctamente.'
                });
                
                const url = window.URL.createObjectURL(res);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'reporte_menores_edad.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        }).catch((error) => {
            Swal.close();
            Swal.fire({
                icon: 'error',
                text: 'Error al descargar el reporte de menores de edad.'
            });
        });
    }

    const handleDescargarReporteAlumnosColumnas = async (columnasSeleccionadas) => {
        Swal.fire({
            title: "Descargando Reporte",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
        });

        try {
            const res = await descargarReporteAlumnosColumnas(idgira, columnasSeleccionadas);
            Swal.close();
            
            if (res.error === true) {
                Swal.fire({
                    icon: 'error',
                    text: 'Error al descargar el reporte.'
                });
            } else {
                const url = window.URL.createObjectURL(res);
                const a = document.createElement('a');
                a.href = url;
                a.download = `reporte_alumnos_${idgira}_${Date.now()}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                Swal.fire({
                    icon: 'success',
                    text: 'Reporte descargado correctamente.'
                });
            }
        } catch (error) {
            Swal.close();
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                text: 'Error al descargar el reporte.'
            });
        }
    }

    // ==================== FUNCIONES PARA DOCUMENTOS DE COORDINADORES ====================

    const handleFileUploadDocumentoCoordinador = (e) => {
      
        setFileDocumentoCoordinador(e.id || "");
    };

    const handleCargarDocumentoCoordinador = async (e) => {
        e.preventDefault();
        
        if (!fileDocumentoCoordinador) {
            Swal.fire("Error", "Por favor selecciona un archivo", "error");
            return;
        }

        if (!docTipoCoordinador) {
            Swal.fire("Error", "Por favor selecciona un tipo de documento", "error");
            return;
        }

        setLoadingDocumentos(true);
        try {
            const resultado = await cargarDocumentoCoordinador(
                parseInt(idgira),
                docTipoCoordinador,
                fileDocumentoCoordinador,
                docDescripcionCoordinador
            );

            if (resultado.error) {
                Swal.fire("Error", resultado.msg || "Error al cargar documento", "error");
            } else {
                Swal.fire("Éxito", "Documento cargado correctamente", "success");
                
                // Recargar la lista de documentos
                const res = await obtenerDocumentosCoordinador(parseInt(idgira));
                if (!res.error) {
                    setDocumentosCoordinador(res.data);
                }
                
                // Limpiar el formulario
                handleCloseUploadDocumentoCoordinador();
            }
        } catch (error) {
            console.error("Error:", error);
            Swal.fire("Error", "Error al cargar el documento", "error");
        } finally {
            setLoadingDocumentos(false);
        }
    };

    const handleDescargarDocumentoCoordinador = async (docId) => {
        try {
            await descargarDocumentoCoordinador(docId);
        } catch (error) {
            console.error("Error al descargar:", error);
            Swal.fire("Error", "Error al descargar el documento", "error");
        }
    };

    const handleEliminarDocumentoCoordinador = (docId) => {
        Swal.fire({
            title: "¿Eliminar documento?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await eliminarDocumentoCoordinador(docId);
                    if (res.error) {
                        Swal.fire("Error", res.msg, "error");
                    } else {
                        Swal.fire("Éxito", "Documento eliminado", "success");
                        
                        // Recargar la lista
                        const resultado = await obtenerDocumentosCoordinador(parseInt(idgira));
                        if (!resultado.error) {
                            setDocumentosCoordinador(resultado.data);
                        }
                    }
                } catch (error) {
                    Swal.fire("Error", "Error al eliminar documento", "error");
                }
            }
        });
    };

    const handleActualizarDescripcionCoordinador = (docId, nuevaDescripcion) => {
        if (!nuevaDescripcion.trim()) {
            Swal.fire("Error", "La descripción no puede estar vacía", "error");
            return;
        }

        Swal.fire({
            title: "Actualizar descripción",
            input: "textarea",
            inputValue: nuevaDescripcion,
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonText: "Cancelar",
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return "La descripción no puede estar vacía";
                }
            }
        }).then(async (result) => {
            if (result.isConfirmed && result.value) {
                try {
                    const res = await actualizarDocumentoCoordinador(docId, result.value);
                    if (res.error) {
                        Swal.fire("Error", res.msg, "error");
                    } else {
                        Swal.fire("Éxito", "Descripción actualizada", "success");
                        
                        // Recargar la lista
                        const resultado = await obtenerDocumentosCoordinador(parseInt(idgira));
                        if (!resultado.error) {
                            setDocumentosCoordinador(resultado.data);
                        }
                    }
                } catch (error) {
                    Swal.fire("Error", "Error al actualizar descripción", "error");
                }
            }
        });
    };

    const handleMultaChange = (cuotaId, nuevaMulta) => {
        const nuevaMultaNumerica = parseFloat(nuevaMulta) || 0; // Convertir la nueva multa a número o usar 0 si no es válida

    // Actualizar la multa modificada
    setMultasModificadas((prevState) => ({
        ...prevState,
        [cuotaId]: nuevaMultaNumerica,
    }));

    console.log("Multas Modificadas:", multasModificadas);

        // Recalcular el monto "A Pagar" y el "Total a Pagar"
        const nuevasCuotas = cuotasAlumnoGira.map((cuota) => {
           
            if (cuota.cuo_id === cuotaId) {
                return {
                    ...cuota,
                    multa: nuevaMultaNumerica,
                    aPagar: cuota.cou_valor + nuevaMultaNumerica, // Actualizar el monto "A Pagar"
                };
            }
            return cuota;
        });

        console.log("Nuevas Cuotas:", nuevasCuotas);

        setCuotasAlumnoGira(nuevasCuotas);
        console.log("Cuotas Alumno Gira:", nuevasCuotas);

        console.log("Selected Cuotas:", selectedCuotas);

         // Recalcular el total a pagar solo para las cuotas seleccionadas
        const nuevoTotalMonto = selectedCuotas.reduce((total, cuotaSeleccionada) => {
            const cuotaActualizada = nuevasCuotas.find((cuota) => cuota.cuo_id === cuotaSeleccionada.cuo_id);
            return total + (cuotaActualizada?.aPagar || (cuotaSeleccionada.cou_valor +  cuotaSeleccionada.multa));
        }, 0);

        setTotalMonto(nuevoTotalMonto);
        };

        const handleDetalleChange = (cuotaId, detalle) => {
            setDetalleModificadas({
                ...detalleModificadas,
                [cuotaId]: detalle || '', // Actualizar la multa para la cuota específica
            });
    };

    const handlePay = async () => {
        // Lógica para procesar el pago
        Swal.fire({
            title: "Registrando pago",
            text: "Por favor, espere...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
         
        try {
            const res = await registrarPagosFuncionario(selectedCuotas, multasModificadas, detalleModificadas, dolar);
            Swal.close();
            const restCuotas = await cuotasAlumno(alumnoSelecionado);
            const sumaTotalCuotas = restCuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);


            const totalCuotasPagadas = restCuotas.filter(cuota => cuota.cou_fpago) // Solo cuotas pagadas (cou_fpago no nulo)
                                        .reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);

             setValorGiraAlumno(sumaTotalCuotas);
            setValorAbono( totalCuotasPagadas);

            // Calcular multas para todas las cuotas
            const nuevasMultas = {};
            for (let i = 0; i < restCuotas.length; i++) {
                const cuota = restCuotas[i];
             
                nuevasMultas[cuota.cuo_id] = cuota.multa;
            }
            setMultasModificadas(nuevasMultas);
                                        
            setCuotasAlumnoGira(restCuotas);
            setTotalMonto(0);
            setSelectedCuotas([]);
            Swal.fire({
                icon: 'success',
                text: 'Pago realizado correctamente.'
            });
        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                text: 'Error al registrar el pago.'
            });
            console.error(error);
        }

    };

    function convertirFecha(fecha) {
        if (!fecha) return "";
        
        // Si ya viene en formato YYYY-MM-DD, retornar como está
        if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
            return fecha;
        }
        
        // Si viene en formato DD/MM/YYYY, convertir a YYYY-MM-DD
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
            const [dia, mes, anio] = fecha.split("/");
            return `${anio}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
        }
        
        return "";
    }

    // Función para validar que todos los campos obligatorios estén completos
    const validarFormulario = () => {
        const camposObligatorios = {
            "Nombres": passengerData.nombres?.trim(),
            "Apellidos": passengerData.apellidos?.trim(),
            "RUT": passengerData.rut?.trim(),
            "Nacionalidad": passengerData.nacionalidad?.trim(),
            "Fecha de Nacimiento": passengerData.fechaNacimiento?.trim(),
            "Enfermedades": passengerData.alu_enfermedad?.trim(),
            "Dieta Alimenticia": passengerData.idalimentacion,
            "Tipo de Sangre": passengerData.idsangre,
            "Tipo de Documento": passengerData.alu_tipo_documento?.trim(),
            "Fecha de Vencimiento del Documento": passengerData.alu_fecha_vencimiento_documento?.trim()
        };

        const camposFaltantes = [];
        
        for (const [nombre, valor] of Object.entries(camposObligatorios)) {
            if (!valor || valor === "" || valor === 0 || valor === "0") {
                camposFaltantes.push(nombre);
            }
        }

        return {
            valido: camposFaltantes.length === 0,
            camposFaltantes
        };
    };

    const handleActualizaDatos = async () => {
        try {
            // Validar que todos los campos obligatorios estén completos
            const validacion = validarFormulario();
            
            if (!validacion.valido) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Campos obligatorios incompletos',
                    html: `<div style="text-align: left;"><strong>Por favor, completa los siguientes campos:</strong><ul style="margin-top: 10px;">
                        ${validacion.camposFaltantes.map(campo => `<li>${campo}</li>`).join('')}
                    </ul></div>`,
                    confirmButtonText: 'Entendido'
                });
                return;
            }

            Swal.fire({
                title: "Actualizando datos",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Preparar datos para enviar al backend
            // Convertir fechas de DD/MM/YYYY a YYYY-MM-DD para MySQL
            // IMPORTANTE: El campo en estado es fechaNacimiento, pero en BD es alu_fnacimiento
            const dataToSend = {
                nombres: passengerData.nombres,
                apellidos: passengerData.apellidos,
                rut: passengerData.rut,
                nacionalidad: passengerData.nacionalidad,
                fnacimiento: passengerData.fechaNacimiento 
                    ? convertirFecha(passengerData.fechaNacimiento) 
                    : null,
                alu_enfermedad: passengerData.alu_enfermedad,
                idalimentacion: passengerData.idalimentacion,
                idsangre: passengerData.idsangre,
                alu_tipo_documento: passengerData.alu_tipo_documento,
                alu_fecha_vencimiento_documento: passengerData.alu_fecha_vencimiento_documento 
                    ? convertirFecha(passengerData.alu_fecha_vencimiento_documento) 
                    : null
            };

            // Llamar a la API para actualizar
            const resultado = await editarAlumnoGira(alumnoSelecionado, dataToSend);

            Swal.close();

            if (resultado.error === false) {
                Swal.fire({
                    icon: 'success',
                    text: 'Datos del pasajero actualizados correctamente'
                });
                setAlertModalDetalle(false);
                // Recargar datos del alumno
                fetchTablaAlumnos(idgira);
            } else {
                Swal.fire({
                    icon: 'error',
                    text: resultado.msg || 'Error al actualizar los datos'
                });
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                text: 'Error al actualizar los datos'
            });
            console.error(error);
        }
    };

  const handleAprobarReembolso = async () => {
    if (!reembolsoMonto) {
      Swal.fire({
        icon: 'warning',
        text: 'Debes indicar el monto del reembolso'
      });
      return;
    }

    const res = await aprobarReembolso(alumnoSelecionado, reembolsoMonto, reembolsoComentario);
    
    if (res.error) {
      Swal.fire({
        icon: 'error',
        text: 'Error al aprobar reembolso'
      });
    } else {
      Swal.fire({
        icon: 'success',
        text: 'Reembolso aprobado correctamente'
      });
      setShowReembolsoModal(false);
      setReembolsoMonto('');
      setReembolsoComentario('');
      setReembolsoAccion(null);
      // Recargar datos del reembolso
      const resReembolso = await obtenerSolicitudReembolso(alumnoSelecionado);
      if (!resReembolso.error && resReembolso.solicitud) {
        setReembolsoData(resReembolso.solicitud);
      }
    }
  };

  const handleRechazarReembolso = async () => {
    if (!reembolsoComentario) {
      Swal.fire({
        icon: 'warning',
        text: 'Debes indicar un motivo para rechazar'
      });
      return;
    }

    const res = await rechazarReembolso(alumnoSelecionado, reembolsoComentario);
    
    if (res.error) {
      Swal.fire({
        icon: 'error',
        text: 'Error al rechazar reembolso'
      });
    } else {
      Swal.fire({
        icon: 'success',
        text: 'Reembolso rechazado correctamente'
      });
      setShowReembolsoModal(false);
      setReembolsoMonto('');
      setReembolsoComentario('');
      setReembolsoAccion(null);
      // Recargar datos del reembolso
      const resReembolso = await obtenerSolicitudReembolso(alumnoSelecionado);
      if (!resReembolso.error && resReembolso.solicitud) {
        setReembolsoData(resReembolso.solicitud);
      }
    }
  };

  const handleShowReembolsoModal = (accion) => {
    setReembolsoAccion(accion);
    setReembolsoMonto('');
    setReembolsoComentario('');
    setShowReembolsoModal(true);
  };

  const handleShowDetalleAlumno = async (alumno) => {
    const res = await getAlumno(alumno.alu_id);
    const restCuotas = await cuotasAlumno(alumno.alu_id);
    
    // Cargar documentos del alumno
    const docsAlumno = await obtenerDocumentosApoderado(alumno.alu_id, gira.gir_id);
    if (!docsAlumno.error && Array.isArray(docsAlumno)) {
      setDocumentosAlumno(docsAlumno);
    } else {
      setDocumentosAlumno([]);
    }

    // Cargar contactos de emergencia
    const contactosResp = await obtenerContactosEmergencia(alumno.alu_id);
    if (!contactosResp.error && Array.isArray(contactosResp.data)) {
      setContactosEmergencia(contactosResp.data);
    } else if (Array.isArray(contactosResp)) {
      setContactosEmergencia(contactosResp);
    } else {
      setContactosEmergencia([]);
    }

    // Obtener responsable del alumno desde la lista de apoderados
    const responsable = alumnos.find(a => a.alu_id === alumno.alu_id);
    if (responsable) {
      setResponsableAlumno({
        usu_nombre: responsable.usu_nombre,
        usu_apellido: responsable.usu_apellido,
        usu_rut: responsable.usu_rut,
        usu_dv: responsable.usu_dv,
        usu_email: responsable.usu_email,
        usu_telefono: responsable.usu_telefono,
        parentesco: responsable.parentesco,
        calidad: responsable.calidad
      });
    } else {
      setResponsableAlumno(null);
    }
    
    setAlumnoSelecionado(alumno.alu_id);
    setPassengerData({
      nombres: res.alu_nombres,
      apellidos: res.alu_apellidos,
      rut: `${res.alu_rut}-${res.alu_dv}`,
      calidad: res.calidad,
      idcalidad: res.idcalidad,
      fechaNacimiento: res.alu_fnacimiento,
      fechaNacimientoAct: convertirFecha(res.alu_fnacimiento),
      sexo: res.sexo,
      alergia: res.alergia,
        nacionalidad: res.alu_nacionalidad,
        edad: res.edad,
        alu_enfermedad: res.alu_enfermedad || '',
        idalimentacion: res.idalimentacion || '',
        idsangre: res.idsangre || '',
        alu_tipo_documento: res.alu_tipo_documento || '',
        alu_fecha_vencimiento_documento: res.alu_fecha_vencimiento_documento || '',
    });

    // Cargar datos de tipo de sangre
    const tipoSangreResp = await tipoSangre();
    if (tipoSangreResp?.data) {
      setTipoSangreData(tipoSangreResp.data);
    }

   
     const sumaTotalCuotas = restCuotas.reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);


    const totalCuotasPagadas = restCuotas.filter(cuota => cuota.cou_fpago) // Solo cuotas pagadas (cou_fpago no nulo)
                                        .reduce((total, cuota) => total + Number(cuota.cou_valor || 0), 0);


    setValorGiraAlumno(sumaTotalCuotas);
    setValorAbono( totalCuotasPagadas);

     // Calcular multas para todas las cuotas
    const nuevasMultas = {};
    for (let i = 0; i < restCuotas.length; i++) {
        const cuota = restCuotas[i];
        
        nuevasMultas[cuota.cuo_id] = cuota.multa;
    }
    setMultasModificadas(nuevasMultas);

    setCuotasAlumnoGira(restCuotas);
   
    // Obtener datos de reembolso si existen
    const resReembolso = await obtenerSolicitudReembolso(alumno.alu_id);
    if (!resReembolso.error && resReembolso.solicitud) {
      setReembolsoData(resReembolso.solicitud);
    } else {
      setReembolsoData(null);
    }
    
    setAlertModalDetalle(true);
    setTotalMonto(0);
    setSelectedCuotas([]);
  };

  const handleCheckboxChange = (cuota, proximaFechaVencimiento) => {
    const isSelected = selectedCuotas.some((item) => item.cuo_id === cuota.cuo_id);
    let newSelectedCuotas;
    let newTotalMonto;

    // Usar la multa modificada si existe, de lo contrario usar la calculada
    
    const multa = multasModificadas[cuota.cuo_id];
   
    if (isSelected) {
        // Si ya está seleccionado, eliminarlo
        newSelectedCuotas = selectedCuotas.filter((item) => item.cuo_id !== cuota.cuo_id);
        newTotalMonto = totalMonto - Number(cuota.cou_valor + multa);
    } else {
        // Si no está seleccionado, agregarlo con la multa
        newSelectedCuotas = [...selectedCuotas, { cuo_id: cuota.cuo_id, multa, cou_valor: cuota.cou_valor }];
        newTotalMonto = totalMonto + Number(cuota.cou_valor + multa);
    }
   console.log("Selected Cuotas:", newSelectedCuotas);
    setSelectedCuotas(newSelectedCuotas);
    setTotalMonto(newTotalMonto);
};


 const calculateMulta = (fechaVencimiento, valorGira, proximaFechaVencimiento = null) => {
    // fechaVencimiento y proximaFechaVencimiento en formato 'dd-mm-yyyy'
    const [day, month, year] = fechaVencimiento.split('-').map(Number);
    const fechaVenc = new Date(year, month - 1, day);

    // Sumar un día para que la multa empiece al día siguiente
    fechaVenc.setDate(fechaVenc.getDate() + 1);
    const fechaActual = new Date(); // fecha actual
    if(fechaActual <= fechaVenc ){
        return 0; // Si la fecha actual es antes o igual a la fecha de vencimiento, no hay multa
    }

    // Determinar hasta cuándo calcular la multa
    let fechaLimite;
    if (proximaFechaVencimiento) {
        const [nextDay, nextMonth, nextYear] = proximaFechaVencimiento.split('-').map(Number);
        fechaLimite = new Date(nextYear, nextMonth - 1, nextDay);
        if(fechaLimite >= fechaActual){
            fechaLimite = new Date(); // Si la próxima cuota es antes o igual a la fecha de vencimiento, no hay multa
        }
    } else {
        fechaLimite = new Date(); // fecha actual si no hay próxima cuota
    }

    // Si la fecha límite es menor o igual a la fecha de inicio de multa, no hay multa
    if (fechaLimite <= fechaVenc) {
        return 0;
    }
   
    if(gira.gir_mulmensual?.data[0]){
        
        return  Math.floor(valorGira * (gira.gir_porcmulta / 100) ); // 1% por semana
    }else{
         // Calcular semanas completas de atraso
        
        const diferenciaEnMilisegundos = fechaLimite - fechaVenc;
        const semanasAtraso = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24 * 7));
       
        if(semanasAtraso === 0){
            return  Math.floor((1)  * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
        }
        return  Math.floor((semanasAtraso )  * (valorGira *  (gira.gir_porcmulta / 100))); // 1% por semana
    }
   
};

    return (
        <div className="mc-card">
            <div className="mc-card-header">
                <h4 className="mc-card-title">Pasajeros</h4>
                <Dropdown bsPrefix="mc-dropdown">
                    <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                        <i className='material-icons'>more_horiz</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" className="mc-dropdown-paper">
                        <button type='button' className='mc-dropdown-menu' onClick={handleShowUploadNominaModal}><i className='material-icons'>group</i><span>Cargar Nómina de Alumnos</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleShowUploadDocModal}><i className='material-icons'>upload</i><span>Agregar Documentación Anexa</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleDescargaInterna}><i className='material-icons'>download</i><span>Descargar Planilla Interna</span></button>
                        <button type='button' className='mc-dropdown-menu'  onClick={handleDescargaAduana}><i className='material-icons'>download</i><span>Descargar Planilla Aduana</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleDescargaLogAcceso}><i className='material-icons'>download</i><span>Descargar Planilla Log de Acceso</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={handleDescargaMenoresEdad}><i className='material-icons'>download</i><span>Descargar Reporte Menores de Edad</span></button>
                        <button type='button' className='mc-dropdown-menu' onClick={() => setShowModalSeleccionarColumnas(true)}><i className='material-icons'>download</i><span>Descargar Reporte con Selección de Columnas</span></button>
                    </Dropdown.Menu>
                </Dropdown> 
            </div>
            <Tabs defaultActiveKey="alumnos" id="mc" className="mc-tabs">
                <Tab eventKey="alumnos" title="Pasajeros" className="mc-tabpane alumnos">
                <ul className="mc-activity-card-list " style={{ height: '2500px', width: '100%' }}>
                    <Row className="mb-3">
                        <Col xl={12}>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por nombre, apellido, RUT del pasajero o responsable..."
                                value={busquedaPasajeros}
                                onChange={(e) => setBusquedaPasajeros(e.target.value)}
                            />
                        </Col>
                    </Row>
               
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                         <th colSpan="3">PASAJERO</th>
                         <th colSpan="4">RESPONSABLE</th>
                         <th>Calidad</th>
                         <th>Estado</th>
                         <th></th>
                        </tr>
                        <tr>
                         
                         <th>Apellido</th>
                         <th>Nombres</th>
                         <th>RUT</th>
                         <th>Nombres</th>
                         <th>Apellido</th>
                         <th>RUT</th>
                         <th>Parentesco</th>
                         <th>Calidad</th>
                         <th>Estado</th>
                         <th></th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {filtrarAlumnos(alumnos, busquedaPasajeros)?.map((item, index) => (
                            <tr key={ index }> 
                             <td title={ item.alu_apellidos }>
                                { item.alu_apellidos }
                                </td>
                                <td title="id">
                                { item.alu_nombres }
                                </td>
                               
                                <td title={ item.alu_rut }>
                                { item.alu_rut }-{ item.alu_dv }
                                </td>
                                <td title={ item.usu_nombre }>
                                { item.usu_nombre }
                                </td>
                                <td title={ item.usu_apellido }>
                                { item.usu_apellido }
                                </td>
                                <td title={ item.usu_rut }>
                                { item.usu_rut }-{ item.usu_dv }
                                </td>
                                <td title={ item.parentesco }>
                                { item.parentesco }
                                </td>
                                <td title={ item.calidad }>
                                { item.calidad }
                                </td>
                               
                                <td title={ item.status }>
                                    { item.genero !== null && <p className="mc-table-badge green">Información Completada</p> }
                                    { item.genero === null && <p className="mc-table-badge red">Sin Información</p> }
                                    { item.cuotas_pagadas_completas === 'PENDIENTE' && <p className="mc-table-badge red">Pendiente de Pago</p> }
                                    { item.cuotas_pagadas_completas === 'PAGADO' && <p className="mc-table-badge green">Pago Completado</p> }
                                </td>
                                
                                <td>
                                    <div className="mc-table-action">
                                    <AnchorComponent  title="ver" onClick={() => handleShowDetalleAlumno(item)} className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                     <ButtonComponent title="Eliminar" onClick={() => { setSelectedAlumno(item); setAlertModalEliminar(true); }}  className="material-icons block"><i className='material-icons'>delete</i></ButtonComponent>  
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
               
                    
                    </ul>
                </Tab>
                <Tab eventKey="nuevos_pasajeros" title="Nuevos Pasajeros" className="mc-tabpane nuevos_pasajeros">
                <ul className="mc-activity-card-list " style={{ height: '2500px', width: '100%' }}>
                    <Row className="mb-3">
                        <Col xl={12}>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por nombre, apellido, RUT del pasajero o responsable..."
                                value={busquedaNuevosPasajeros}
                                onChange={(e) => setBusquedaNuevosPasajeros(e.target.value)}
                            />
                        </Col>
                    </Row>
               
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                         <th colSpan="3">PASAJERO</th>
                         <th colSpan="4">RESPONSABLE</th>
                         <th>Calidad</th>
                         <th>Estado</th>
                         <th></th>
                        </tr>
                        <tr>
                         <th>Nombres</th>
                         <th>Apellido</th>
                         <th>RUT</th>
                         <th>Nombres</th>
                         <th>Apellido</th>
                         <th>RUT</th>
                         <th>Parentesco</th>
                         <th>Calidad</th>
                         <th>Estado</th>
                         <th></th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {filtrarAlumnos(alumnos?.filter(item => item.nuevo === true || item.nuevo === 1), busquedaNuevosPasajeros)?.map((item, index) => (
                            <tr key={ index }> 
                                <td title="id">
                                { item.alu_nombres }
                                </td>
                                <td title={ item.alu_apellidos }>
                                { item.alu_apellidos }
                                </td>
                                <td title={ item.alu_rut }>
                                { item.alu_rut }-{ item.alu_dv }
                                </td>
                                <td title={ item.usu_nombre }>
                                { item.usu_nombre }
                                </td>
                                <td title={ item.usu_apellido }>
                                { item.usu_apellido }
                                </td>
                                <td title={ item.usu_rut }>
                                { item.usu_rut }-{ item.usu_dv }
                                </td>
                                <td title={ item.parentesco }>
                                { item.parentesco }
                                </td>
                                <td title={ item.calidad }>
                                { item.calidad }
                                </td>
                               
                                <td title={ item.status }>
                                    { item.genero !== null && <p className="mc-table-badge green">Información Completada</p> }
                                    { item.genero === null && <p className="mc-table-badge red">Sin Información</p> }
                                    { item.cuotas_pagadas_completas === 'PENDIENTE' && <p className="mc-table-badge red">Pendiente de Pago</p> }
                                    { item.cuotas_pagadas_completas === 'PAGADO' && <p className="mc-table-badge green">Pago Completado</p> }
                                </td>
                                
                                <td>
                                    <div className="mc-table-action">
                                    <AnchorComponent  title="ver" onClick={() => handleShowDetalleAlumno(item)} className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                     <ButtonComponent title="Eliminar" onClick={() => { setSelectedAlumno(item); setAlertModalEliminar(true); }}  className="material-icons block"><i className='material-icons'>delete</i></ButtonComponent>  
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
               
                    
                    </ul>
                </Tab>
                <Tab eventKey="password" title="Bajas de pasajero" className="mc-tabpane password">
                <ul className="mc-activity-card-list " style={{ height: '2500px', width: '100%' }}>
               
                    <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                        <th >Nombres</th>
                         <th >Apellido</th>
                         <th >RUT</th>
                        
                        
                        
                         <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {alumnosEliminados?.map((item, index) => (
                            <tr key={ index }> 
                                <td title="id">
                                { item.alu_nombres }
                                </td>
                                <td title={ item.name }>
                                { item.alu_apellidos }
                                </td>
                                <td title={ item.name }>
                                { item.alu_rut }-{ item.alu_dv }
                                </td>
                              
                               
                              
                                
                                <td>
                                    <div className="mc-table-action">
                                    <ButtonComponent title="Subir Pasajero" onClick={() => handleSubirPasajero(item)} className="material-icons view"><i className='material-icons'>person_add</i></ButtonComponent>
                                    </div>
                                </td>
                             
                            </tr>
                        ))}
                    </tbody>
                 </table>
    
              
                    </ul>
                </Tab> 
                <Tab eventKey="apoderados" title="Responsables" className="mc-tabpane apoderados">
                <ul className="mc-activity-card-list " style={{ height: '2500px', width: '100%' }}  >
                    <div style={{ padding: '20px' }}>
                        {responsableActual && (
                            <div style={{ 
                                marginBottom: '20px', 
                                padding: '15px', 
                                backgroundColor: '#e8f5e9', 
                                borderRadius: '4px',
                                borderLeft: '4px solid #4caf50'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#2e7d32' }}>
                                    <i className='material-icons' style={{ fontSize: '1.2rem', marginRight: '8px', verticalAlign: 'middle' }}>check_circle</i>
                                    Responsable Actual
                                </h5>
                                <p style={{ marginBottom: '5px' }}>
                                    <strong>{responsableActual.usu_nombre} {responsableActual.usu_apellido}</strong>
                                </p>
                                <p style={{ marginBottom: '0px', fontSize: '0.9rem', color: '#555' }}>
                                    RUT: {responsableActual.usu_rut}-{responsableActual.usu_dv}
                                </p>
                            </div>
                        )}
                        
                        <h5 style={{ marginBottom: '15px' }}>Cambiar Responsable</h5>
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ marginBottom: '10px', display: 'block' }}>Selecciona un nuevo responsable:</label>
                            <select 
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    fontSize: '1rem'
                                }}
                                value={apoSeleccionadoResponsable?.usu_id ? String(apoSeleccionadoResponsable.usu_id) : ''}
                                onChange={(e) => {
                                    const apo = apoderados.find(a => String(a.usu_id) === e.target.value);
                                    console.log("Apoderado seleccionado:", apo);
                                    setApoSeleccionadoResponsable(apo || null);
                                }}
                            >
                                <option value="">-- Selecciona un apoderado --</option>
                                {apoderados?.map((apo, index) => (
                                    <option key={index} value={String(apo.usu_id)}>
                                        {apo.usu_nombre} {apo.usu_apellido} 
                                    </option>
                                ))}
                            </select>
                        </div>
                        
                        <ButtonComponent 
                            onClick={handleCambiarResponsable}
                            className="btn btn-primary"
                            style={{ marginRight: '10px' }}
                        >
                            <i className='material-icons' style={{ fontSize: '1rem', marginRight: '5px' }}>person</i>
                            Asignar como Responsable
                        </ButtonComponent>
                    </div>

                    <div style={{ padding: '20px', marginTop: '20px', borderTop: '1px solid #ddd' }}>
                        <h5 style={{ marginBottom: '15px' }}>Listado de Apoderados</h5>
                        <table className="mc-table">
                            <thead className="mc-table-head primary">
                                <tr>
                                    <th>Nombre</th>
                                    <th>RUT</th>
                                    <th>Alumnos</th>
                                    <th>Estado</th>
                                   
                                </tr>
                            </thead>
                            <tbody className="mc-table-body even">
                                {apoderados?.map((apo, index) => (
                                    <tr key={index}>
                                        <td>
                                            <strong>{apo.usu_nombre} {apo.usu_apellido}</strong>
                                            {responsableActual && responsableActual.usu_id === apo.usu_id && (
                                                <span style={{ 
                                                    marginLeft: '10px', 
                                                    padding: '3px 8px', 
                                                    backgroundColor: '#4caf50', 
                                                    color: 'white',
                                                    borderRadius: '3px',
                                                    fontSize: '0.8rem',
                                                    fontWeight: 'bold'
                                                }}>
                                                    Responsable
                                                </span>
                                            )}
                                        </td>
                                        <td>{apo.usu_rut}-{apo.usu_dv}</td>
                                        <td>
                                            {apo.alumnos?.map((alu, index) => (
                                                <div key={index}>
                                                    <br />{alu.alu_nombres} {alu.alu_apellidos}
                                                </div>
                                            ))}
                                        </td>
                                       
                                        <td>
                                            {apo.apo_responsable_gira === 1  && (
                                                <p className="mc-table-badge green">Responsable</p>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </ul>
                </Tab>
                <Tab eventKey="documentos" title="Documentos" className="mc-tabpane documentos">
                <ul className="mc-activity-card-list " style={{ height: '2500px', width: '100%' }}>
               
                   <table className="mc-table">
                    <thead className="mc-table-head primary">
                        <tr>
                            
                        <th >Nombre Archivo</th>
                        <th >Fecha</th>
                        <th >Descargar</th>
                        
                        
                        
                        
                       
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                    {documentosGira?.map((item, index) => (
                            <tr key={ index }>  

                                <td title="id">
                                { item.doc_nombre }
                                </td>   
                                <td title="id">
                                { formatearFecha(item.fecha_subida) }
                                </td>
                                <td title="id">
                                 <button type='button' className='mc-dropdown-menu' onClick={() => handleDownload(item.fil_id,  item.doc_nombre)}><i className='material-icons'>download</i><span>Descargar</span></button>
                                </td>  
                            </tr>
                            
                        ))}    

                    </tbody>
                    </table>
    
              
                    </ul>
                </Tab>
                <Tab eventKey="documentos_coordinador" title="Documentos de Coordinador" className="mc-tabpane documentos_coordinador">
                <ul className="mc-activity-card-list " style={{ height: '2500px', width: '100%' }}>
                    <div style={{ padding: '20px' }}>
                        <ButtonComponent 
                            onClick={handleShowUploadDocumentoCoordinador}
                            className="btn btn-primary"
                            style={{ marginBottom: '20px' }}
                        >
                            <i className='material-icons' style={{ fontSize: '1rem', marginRight: '5px' }}>add</i>
                            Cargar Nuevo Documento
                        </ButtonComponent>

                        {documentosCoordinador && documentosCoordinador.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                {documentosCoordinador.map((doc) => (
                                    <div
                                        key={doc.doc_id}
                                        style={{
                                            padding: '15px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            backgroundColor: '#f9f9f9'
                                        }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                                            <div style={{ flex: 1 }}>
                                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', fontSize: '1rem' }}>
                                                    {doc.doc_nombre}
                                                </p>
                                                {doc.usu_nombre && (
                                                    <p style={{ margin: '5px 0', fontSize: '0.85rem', color: '#666' }}>
                                                        <strong>Cargado por:</strong> {doc.usu_nombre} {doc.usu_apellido}
                                                    </p>
                                                )}
                                                {doc.doc_tipo && (
                                                    <p style={{ margin: '5px 0', fontSize: '0.85rem', color: '#666' }}>
                                                        <strong>Tipo:</strong> {doc.doc_tipo}
                                                    </p>
                                                )}
                                                {doc.doc_descripcion && (
                                                    <p style={{ margin: '10px 0 5px 0', fontSize: '0.85rem', backgroundColor: '#e8f4f8', padding: '8px', borderRadius: '3px' }}>
                                                        <strong>Descripción:</strong> {doc.doc_descripcion}
                                                    </p>
                                                )}
                                                <p style={{ margin: '5px 0 0 0', fontSize: '0.75rem', color: '#999' }}>
                                                    {new Date(doc.created_at).toLocaleDateString('es-CL')} a las {new Date(doc.created_at).toLocaleTimeString('es-CL')}
                                                </p>
                                            </div>
                                            <div style={{ display: 'flex', gap: '10px', marginLeft: '20px' }}>
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => handleDescargarDocumentoCoordinador(doc.doc_id)}
                                                    style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                                                    title="Descargar"
                                                >
                                                    <i className='material-icons' style={{ fontSize: '1rem' }}>download</i>
                                                </button>
                                               
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => handleEliminarDocumentoCoordinador(doc.doc_id)}
                                                    style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                                                    title="Eliminar"
                                                >
                                                    <i className='material-icons' style={{ fontSize: '1rem' }}>delete</i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p style={{ color: '#999', textAlign: 'center', padding: '40px 20px' }}>
                                <i className='material-icons' style={{ fontSize: '2rem', display: 'block', marginBottom: '10px' }}>folder_open</i>
                                No hay documentos cargados
                            </p>
                        )}
                    </div>
                </ul>
                </Tab>    
            </Tabs>    
           
            <Modal show={ alertModal } onHide={()=> setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>¿Desea eliminar este usuario?</h3>
                  
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> setAlertModal(false)}>Aceptar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            <Modal show={showUploadModal} onHide={handleCloseUploadModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Subir Listado de Pasajeros</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SingleFileUploadButton
                        onFileUpload={handleFileUpload}
                        type="Xlsx"
                        acceptTypes={acceptTypes}
                        maxSize="50"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseUploadModal}>
                            Cerrar
                        </ButtonComponent>
                        <ButtonComponent variant="primary" className="btn btn-secondary" onClick={handleCargarData}>
                            Subir
                        </ButtonComponent>
                    </Modal.Footer>
                    </div>
            </Modal>

            <Modal show={showUploadModalDoc} onHide={handleCloseUploadModalDoc}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Subir Documentación Anexa</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SingleFileUploadButton
                        onFileUpload={handleFileUploadDoc}
                        type="pdf"
                        acceptTypes={acceptTypesDoc}
                        maxSize="50"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseUploadModalDoc}>
                            Cerrar
                        </ButtonComponent>
                        <ButtonComponent variant="primary" className="btn btn-secondary" onClick={handleCargarDataDoc}>
                            Subir
                        </ButtonComponent>
                    </Modal.Footer>
                    </div>
            </Modal>

            <Modal show={showUploadModalNomina} onHide={handleCloseUploadNominaModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Cargar Nómina de Alumnos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SingleFileUploadButton
                        onFileUpload={handleFileUploadNomina}
                        type="Xlsx"
                        acceptTypes={acceptTypes}
                        maxSize="50"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseUploadNominaModal}>
                            Cerrar
                        </ButtonComponent>
                        <ButtonComponent variant="primary" className="btn btn-secondary" onClick={handleCargarNomina}>
                            Subir
                        </ButtonComponent>
                    </Modal.Footer>
                    </div>
            </Modal>

            <Modal show={showAddPassengerModal} onHide={handleCloseAddPassengerModal}>
            <div className="mc-alert-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formNombres">
                            <Form.Label>Nombres</Form.Label>
                            <Form.Control type="text" name="nombres" value={passengerData.nombres} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formApellidos">
                            <Form.Label>Apellidos</Form.Label>
                            <Form.Control type="text" name="apellidos" value={passengerData.apellidos} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Nacionalidad</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaNacimiento">
                            <Form.Label>Fecha Nacimiento</Form.Label>
                            <Form.Control type="date" name="fechaNacimiento" value={passengerData.fechaNacimiento} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formSexo">
                            <Form.Label>Sexo</Form.Label>
                            <Form.Control as="select" name="sexo" value={passengerData.sexo} onChange={handleInputChange}>
                                <option value="">Seleccionar</option>
                                <option value="M">Masculino</option>
                                <option value="F">Femenino</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formSexo">
                            <Form.Label>Calidad</Form.Label>
                            <Form.Control as="select" name="sexo" value={passengerData.sexo} onChange={handleInputChange}>
                                <option value="">Seleccionar</option>
                                <option value="M">Alumno</option>
                                <option value="F">Apoderado</option>
                                <option value="F">Invitado</option>
                            </Form.Control>
                        </Form.Group>
                        
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Enfermedad</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Tratamiento</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Tipo Sangre</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAlergia">
                            <Form.Label>Tipo Alimentacion</Form.Label>
                            <Form.Control type="text" name="alergia" value={passengerData.alergia} onChange={handleInputChange} />
                        </Form.Group>
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" className="btn btn-danger" onClick={handleCloseAddPassengerModal}>
                        Cerrar
                    </ButtonComponent>
                    <ButtonComponent variant="primary" className="btn btn-primary" onClick={handleAddPassenger}>
                        Agregar
                    </ButtonComponent>
                </Modal.Footer>
                </div>
            </Modal>


            <Modal show={alertModalAgregar} onHide={()=> setAlertModalAgregar(false)}>
            <div className="mc-alert-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formNombres">
                            <Form.Label>Nombres</Form.Label>
                            <Form.Control type="text" name="nombres" value={passengerData.nombres} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formApellidos">
                            <Form.Label>Apellidos</Form.Label>
                            <Form.Control type="text" name="apellidos" value={passengerData.apellidos} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Calidad</Form.Label>
                            <Form.Select name="calidad" onChange={handleInputChange} >
                                                        <option>Seleccionar Calidad</option>
                                                        {tipoPasajeros.map((tipo) => (
                                                            <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                                                        ))}
                                                    </Form.Select>
                        </Form.Group>
                         
                       
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" className="btn btn-danger" onClick={()=> setAlertModalAgregar(false)}>
                        Cerrar
                    </ButtonComponent>
                    <ButtonComponent variant="primary" className="btn btn-primary" onClick={handleAgregarAlumno}>
                        Agregar
                    </ButtonComponent>
                </Modal.Footer>
                </div>
            </Modal>


            <Modal show={alertModalDetalle} onHide={()=> setAlertModalDetalle(false)}>
            <div className="mc-alert-modal" style={{width: '1300px'}}>
                <Modal.Header closeButton>
                    <Modal.Title>Detalle Pasajero</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs className="mc-tabs">
                        <Tab eventKey="profile" title="Perfil">
                        <Form>
                        <Form.Group controlId="formNombres">
                            <Form.Label>Nombres</Form.Label>
                            <Form.Control type="text" name="nombres" value={passengerData.nombres}   onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formApellidos">
                            <Form.Label>Apellidos</Form.Label>
                            <Form.Control type="text" name="apellidos" value={passengerData.apellidos}  onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.rut} onChange={handleInputChange}  />
                        </Form.Group>
                       
                        <Form.Group controlId="formRUT">
                            <Form.Label>Nacionalidad</Form.Label>
                            <Form.Control type="text" name="nacionalidad" value={passengerData.nacionalidad} onChange={handleInputChange}  />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Fecha Nacimiento</Form.Label>
                            <Form.Control 
                                type="date" 
                                name="fechaNacimientoAct" 
                                value={formatDateForInput(passengerData.fechaNacimiento) || passengerData.fechaNacimientoAct || ""}
                                onChange={(e) => {
                                    const formattedDate = formatDateForSave(e.target.value);
                                    setPassengerData({ ...passengerData, fechaNacimiento: formattedDate, fechaNacimientoAct: e.target.value });
                                }}
                            />
                        </Form.Group>
                        <Form.Group controlId="formRUT">
                            <Form.Label>Edad</Form.Label>
                            <Form.Control type="text" name="rut" value={passengerData.edad} onChange={handleInputChange} disabled />
                        </Form.Group>

                         <Form.Group controlId="formRUT">
                            <Form.Label>Calidad</Form.Label>
                            <Form.Select name="calidad" onChange={handleInputChange} disabled >
                                                        <option>Seleccionar Calidad</option>
                                                        {tipoPasajeros.map((tipo) => (
                                                              <option key={tipo.id} value={tipo.id} selected={passengerData?.idcalidad === tipo.id}>{tipo.nombre}</option>
                                                        ))}
                                                    </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formEnfermedad">
                            <Form.Label>Enfermedades</Form.Label>
                            <Form.Control
                                type="text"
                                name="alu_enfermedad"
                                value={passengerData.alu_enfermedad || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="formDietaAlimenticia">
                            <Form.Label>Dieta Alimenticia</Form.Label>
                            <Form.Select
                                name="idalimentacion"
                                value={passengerData.idalimentacion || ""}
                                onChange={handleInputChange}
                            >
                                <option value="">Seleccionar</option>
                                {tipoAlimentacionData.map((tipo) => (
                                    <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formTipoSangre">
                            <Form.Label>Tipo de Sangre</Form.Label>
                            <Form.Select
                                name="idsangre"
                                value={passengerData.idsangre || ""}
                                onChange={handleInputChange}
                            >
                                <option value="">Seleccionar</option>
                                {tipoSangreData.map((s) => (
                                    <option key={s.id} value={s.id}>{s.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <hr />
                        <h6 className="mb-3"><strong>Documento para Viaje</strong></h6>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Tipo de Documento</strong></Form.Label>
                                    <Form.Select
                                        name="alu_tipo_documento"
                                        value={passengerData.alu_tipo_documento || ""}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Seleccionar...</option>
                                        <option value="Cedula de Identidad">Cédula de Identidad</option>
                                        <option value="Pasaporte">Pasaporte</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Fecha de Vencimiento del Documento</strong></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="alu_fecha_vencimiento_documento"
                                        value={formatDateForInput(passengerData.alu_fecha_vencimiento_documento) || ""}
                                        onChange={(e) => {
                                            const formattedDate = formatDateForSave(e.target.value);
                                            setPassengerData({ ...passengerData, alu_fecha_vencimiento_documento: formattedDate });
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                       <Form.Group>
                                    <br></br>               
                          <ButtonComponent type="button" onClick={handleActualizaDatos}  className="btn btn-primary">Actualizar Datos</ButtonComponent>
                       </Form.Group>
                       

                       
                         
                       
                        
                    </Form>
                        </Tab>
                        <Tab eventKey="password" title=" Pagos" className="mc-tabpane password">
                         
                        <h2>Total Gira: {formatearMoneda(valorGiraAlumno)}</h2>
                        {gira?.gir_pagodolares?.data[0] && dolar && (
                            <div className="mb-3">
                                <p className="text-muted mb-1">
                                    <small><strong>Valor del dólar actual:</strong> ${dolar.toLocaleString('es-CL')} CLP</small>
                                </p>
                                <p className="text-info">
                                    <small><i className="material-icons" style={{fontSize: '14px', verticalAlign: 'middle'}}>info</i> Los pagos se registrarán con este valor del dólar</small>
                                </p>
                            </div>
                        )}
                        
                        <table className="mc-table">
                                            <thead className="mc-table-head primary">
                                                <tr>
                                                <th ></th>   
                                                 <th >Nº Cuota</th>
                                                 <th >vencimiento</th>
                                                 <th >Cuota</th>
                                                 <th >Multa</th>
                                                 <th >A Pagar</th>
                                                 <th >Fecha Pago</th>
                                                 <th >Monto Pagado</th>
                                                 <th >Detalle</th>
                                                
                                                </tr>
                                            </thead>
                                            <tbody className="mc-table-body even">
                                            {cuotasAlumnoGira.map((cuota, index) => {
                                               
                                                    const proximaCuota = cuotasAlumnoGira[index + 1];
                                                    const proximaFechaVencimiento = proximaCuota ? proximaCuota.cou_festpago : null;
                                                  
                                                    
                                               
                                                return (
                                                <tr key={cuota.cuo_id}>
                                                    <td>
                                                    {!cuota.cou_fpago && <input type="checkbox" onChange={() => handleCheckboxChange(cuota, proximaFechaVencimiento)} />}
                                                    </td>
                                                    <td title="id">{cuota.cou_ncuota}</td>
                                                    <td title={cuota.cou_festpago}>{cuota.cou_festpago}</td>
                                                    <td title={cuota.cou_valor}>{formatearMoneda(cuota.cou_valor)}</td>
                                                    <td title="multa"> 
                                                         {!cuota.cou_fpago ?
                                                          (<input
                                                            className = {`mc-label-field-input w-md h-sm`}     
                                                            type="text"
                                                            value={multasModificadas[cuota.cuo_id] } // Mostrar la multa modificada o la calculada // Mostrar la multa calculada o la modificada
                                                            onChange={(e) => handleMultaChange(cuota.cuo_id, e.target.value)} // Manejar el cambio
                                                            style={{ width: "100px" }} // Ajustar el tamaño del campo de texto
                                                        />): formatearMoneda(cuota.cou_multa || 0)}
                                                       </td> {/* Mostrar la multa calculada */}
                                                   <td title="apagar"> {cuota.cou_fpago ?
                                                          formatearMoneda(Math.floor(cuota.cou_valor + (cuota.cou_multa || 0))) : formatearMoneda(Math.floor(cuota.cou_valor + multasModificadas[cuota.cuo_id]))}
                                                        </td>
                                                    <td title={cuota.cou_fpago}>{cuota.cou_fpago}</td>
                                                    <td title={cuota.cou_montopagado}>{formatearMoneda(cuota.cou_montopagado || 0)}</td>
                                                    <td title={cuota.cou_detalle}>
                                                          {!cuota.cou_fpago ? (
                                                            <input
                                                            className={`mc-label-field-input w-md h-sm`}
                                                            type="text"
                                                            onChange={(e) => handleDetalleChange(cuota.cuo_id, e.target.value)} // Manejar el cambio
                                                            style={{ width: "80px" }} // Ajustar el tamaño del campo de texto
                                                            />
                                                        ) : (
                                                            <>
                                                            {cuota.cou_detalle}

                                                            {cuota.web_id !== null && <p>Pago con Webpay</p>}
                                                            {cuota.khi_id !== null && <p>Pago con Khipu</p>}
                                                            
                                                            {/* Mostrar valor del dólar si la gira es en dólares y existe valor del dólar del pago */}
                                                            {gira?.gir_pagodolares?.data[0] && cuota.cou_valordolar && (
                                                                <p className="text-muted">
                                                                    <small>Dólar: ${cuota.cou_valordolar.toLocaleString('es-CL')}</small>
                                                                </p>
                                                            )}
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                            </tbody>
                                         </table>
                                          <div className="total-monto">
                                                                 <h5>Total a Pagar: {formatearMoneda(totalMonto)}</h5>
                                                                 {gira?.gir_pagodolares?.data[0] && totalMonto > 0 && dolar && (
                                                                     <p className="text-muted">
                                                                         <small>Equivalente: ${Math.round(totalMonto * dolar).toLocaleString('es-CL')} CLP (Dólar: ${dolar.toLocaleString('es-CL')})</small>
                                                                     </p>
                                                                 )}
                                                             </div>
                                                            
                                                             <ButtonComponent onClick={handlePay}  className="btn btn-primary">Pagar</ButtonComponent>
                                   
                        </Tab>
                        <Tab eventKey="documentos" title="Documentos Cargados" className="mc-tabpane documentos">
                            <div>
                                {documentosAlumno.length === 0 ? (
                                    <p style={{ color: '#999', textAlign: 'center', padding: '20px' }}>
                                        No hay documentos cargados
                                    </p>
                                ) : (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {documentosAlumno.map((doc) => (
                                            <div
                                                key={doc.doc_id}
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    backgroundColor: '#f9f9f9'
                                                }}
                                            >
                                                <div>
                                                    <p style={{ margin: 0, fontWeight: 'bold' }}>
                                                        {doc.doc_tipo === 'permiso_notarial' && 'Permiso Notarial'}
                                                        {doc.doc_tipo === 'documento_viaje' && 'Documento de Viaje (Carnet o Pasaporte)'}
                                                        {doc.doc_tipo === 'receta_medica' && 'Receta Médica o Certificado Médico'}
                                                    </p>
                                                    <p style={{ margin: '5px 0 0 0', fontSize: '0.85rem', color: '#666' }}>
                                                        {doc.doc_nombre}
                                                    </p>
                                                    <p style={{ margin: '2px 0 0 0', fontSize: '0.8rem', color: '#999' }}>
                                                        {new Date(doc.created_at).toLocaleDateString('es-CL')}
                                                    </p>
                                                </div>
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => descargarDocumentoApoderado(doc.doc_id)}
                                                    style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                                                >
                                                    <i className='material-icons' style={{ fontSize: '1rem' }}>download</i>
                                                    Descargar
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Tab>
                        {reembolsoData && reembolsoData.alu_reembolso_solicitado ? (
                            <Tab eventKey="reembolso" title="Reembolso Solicitado" className="mc-tabpane reembolso">
                                <div style={{ padding: '20px' }}>
                                    <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                                        <h5>Estado de Solicitud: <span style={{ color: reembolsoData.alu_reembolso_estado === 'pendiente' ? '#ff9800' : reembolsoData.alu_reembolso_estado === 'aprobado' ? '#4caf50' : '#f44336' }}>
                                            {reembolsoData.alu_reembolso_estado.charAt(0).toUpperCase() + reembolsoData.alu_reembolso_estado.slice(1)}
                                        </span></h5>
                                        <p><strong>Fecha de Solicitud:</strong> {reembolsoData.alu_reembolso_fecha}</p>
                                        <p><strong>Motivo:</strong> {reembolsoData.alu_reembolso_motivo}</p>
                                        {reembolsoData.alu_reembolso_monto && <p><strong>Monto Reembolso:</strong> ${Number(reembolsoData.alu_reembolso_monto).toLocaleString('es-CL')}</p>}
                                        {reembolsoData.alu_reembolso_comentario_empresa && <p><strong>Comentario Empresa:</strong> {reembolsoData.alu_reembolso_comentario_empresa}</p>}
                                        {reembolsoData.fil_reembolso_id && (
                                            <div style={{ marginTop: '15px' }}>
                                                <p><strong>Archivo Adjunto:</strong></p>
                                                <button 
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => descargarArchivoReembolso(reembolsoData.fil_reembolso_id)}
                                                >
                                                    <i className='material-icons' style={{ fontSize: '1rem' }}>download</i> Descargar Documento
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {reembolsoData.alu_reembolso_estado === 'pendiente' && (
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <ButtonComponent onClick={() => handleShowReembolsoModal('aprobar')} className="btn btn-success">
                                                <i className='material-icons' style={{ fontSize: '1rem', marginRight: '5px' }}>check_circle</i>
                                                Aprobar Reembolso
                                            </ButtonComponent>
                                            <ButtonComponent onClick={() => handleShowReembolsoModal('rechazar')} className="btn btn-danger">
                                                <i className='material-icons' style={{ fontSize: '1rem', marginRight: '5px' }}>cancel</i>
                                                Rechazar Reembolso
                                            </ButtonComponent>
                                        </div>
                                    )}
                                </div>
                            </Tab>
                        ) : null}
                        <Tab eventKey="contactoEmergencia" title="Contacto de Emergencia" className="mc-tabpane contactoEmergencia">
                            <div style={{ padding: '20px' }}>
                                {contactosEmergencia && contactosEmergencia.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                        {contactosEmergencia.map((contacto, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    padding: '15px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#f9f9f9'
                                                }}
                                            >
                                                <div style={{ marginBottom: '10px' }}>
                                                    <h6 style={{ margin: '0 0 10px 0', color: '#333' }}>
                                                        <i className='material-icons' style={{ fontSize: '1.2rem', marginRight: '8px', verticalAlign: 'middle', color: '#ff5722' }}>person</i>
                                                        <strong>{contacto.cem_nombre} {contacto.cem_apellido}</strong>
                                                    </h6>
                                                </div>
                                                <div style={{ fontSize: '0.9rem', color: '#555' }}>
                                                    <p style={{ margin: '5px 0' }}>
                                                        <strong>RUT:</strong> {formatRUT(`${contacto.cem_rut}`)}
                                                    </p>
                                                     <p style={{ margin: '5px 0' }}>
                                                        <strong>NombreS:</strong> {contacto.cem_nombres}
                                                    </p>
                                                    <p style={{ margin: '5px 0' }}>
                                                        <strong>Apellidos:</strong> {contacto.cem_apellidos}
                                                    </p>
                                                    <p style={{ margin: '5px 0' }}>
                                                        <strong>Parentesco:</strong> {contacto.cem_parentesco || 'N/A'}
                                                    </p>
                                                    <p style={{ margin: '5px 0' }}>
                                                        <strong>Teléfono:</strong> {contacto.cem_celular || 'N/A'}
                                                    </p>
                                                    <p style={{ margin: '5px 0' }}>
                                                        <strong>Email:</strong> {contacto.cem_email || 'N/A'}
                                                    </p>
                                                    {contacto.cem_direccion && (
                                                        <p style={{ margin: '5px 0' }}>
                                                            <strong>Dirección:</strong> {contacto.cem_direccion}
                                                        </p>
                                                    )}
                                                    {contacto.cem_ciudad && (
                                                        <p style={{ margin: '5px 0' }}>
                                                            <strong>Ciudad:</strong> {contacto.cem_ciudad}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                                        <i className='material-icons' style={{ fontSize: '2.5rem', display: 'block', marginBottom: '10px' }}>person_add</i>
                                        <p><strong>Sin contacto de emergencia registrado</strong></p>
                                    </div>
                                )}
                            </div>
                        </Tab>
                        <Tab eventKey="responsable" title="Responsable" className="mc-tabpane responsable">
                            <div style={{ padding: '20px' }}>
                                {responsableAlumno ? (
                                    <div>
                                        <div style={{ 
                                            marginBottom: '20px', 
                                            padding: '20px', 
                                            backgroundColor: '#e8f5e9', 
                                            borderRadius: '4px',
                                            borderLeft: '4px solid #4caf50'
                                        }}>
                                            <h5 style={{ marginBottom: '15px', color: '#2e7d32', margin: '0 0 15px 0' }}>
                                                <i className='material-icons' style={{ fontSize: '1.2rem', marginRight: '8px', verticalAlign: 'middle' }}>account_circle</i>
                                                Información del Responsable
                                            </h5>
                                            
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                                <div>
                                                    <p style={{ marginBottom: '10px', color: '#555' }}>
                                                        <strong>Nombres:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '1rem', color: '#333' }}>
                                                        {responsableAlumno.usu_nombre}
                                                    </p>

                                                    <p style={{ marginBottom: '10px', color: '#555' }}>
                                                        <strong>Apellidos:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '1rem', color: '#333' }}>
                                                        {responsableAlumno.usu_apellido}
                                                    </p>

                                                    <p style={{ marginBottom: '10px', color: '#555' }}>
                                                        <strong>RUT:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '1rem', color: '#333' }}>
                                                       
                                                        {formatRUT(`${responsableAlumno.usu_rut}${responsableAlumno.usu_dv}`)}
                                                    </p>
                                                </div>

                                                <div>
                                                    <p style={{ marginBottom: '10px', color: '#555' }}>
                                                        <strong>Email:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '1rem', color: '#333' }}>
                                                        {responsableAlumno.usu_email || 'N/A'}
                                                    </p>

                                                    <p style={{ marginBottom: '10px', color: '#555' }}>
                                                        <strong>Teléfono:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '1rem', color: '#333' }}>
                                                        {responsableAlumno.usu_telefono || 'N/A'}
                                                    </p>

                                                    <p style={{ marginBottom: '10px', color: '#555' }}>
                                                        <strong>Parentesco:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '1rem', color: '#333' }}>
                                                        {responsableAlumno.parentesco || 'N/A'}
                                                    </p>
                                                </div>
                                            </div>

                                           
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                                        <i className='material-icons' style={{ fontSize: '2.5rem', display: 'block', marginBottom: '10px' }}>person_outline</i>
                                        <p><strong>Sin responsable asignado</strong></p>
                                    </div>
                                )}
                            </div>
                        </Tab>
                    </Tabs>
                   
                    
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" className="btn btn-danger" onClick={()=> setAlertModalDetalle(false)}>
                        Cerrar
                    </ButtonComponent>
                   
                </Modal.Footer>
                </div>
            </Modal>

            <Modal show={alertModalEliminar} onHide={() => setAlertModalEliminar(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>¿Desea eliminar este alumno?</h3>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModalEliminar(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={handleDeleteAlumno}>Aceptar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            <Modal show={showReembolsoModal} onHide={() => setShowReembolsoModal(false)}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {reembolsoAccion === 'aprobar' ? 'Aprobar Reembolso' : 'Rechazar Reembolso'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {reembolsoAccion === 'aprobar' ? (
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Monto del Reembolso ($)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={reembolsoMonto}
                                        onChange={(e) => setReembolsoMonto(e.target.value)}
                                        placeholder="Ingresa el monto a reembolsar"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Comentario (Opcional)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={reembolsoComentario}
                                        onChange={(e) => setReembolsoComentario(e.target.value)}
                                        placeholder="Agrega un comentario sobre la aprobación"
                                    />
                                </Form.Group>
                            </Form>
                        ) : (
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Motivo del Rechazo</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={reembolsoComentario}
                                        onChange={(e) => setReembolsoComentario(e.target.value)}
                                        placeholder="Indica el motivo del rechazo"
                                    />
                                </Form.Group>
                            </Form>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent 
                            variant="secondary" 
                            className="btn btn-danger" 
                            onClick={() => setShowReembolsoModal(false)}
                        >
                            Cancelar
                        </ButtonComponent>
                        <ButtonComponent 
                            variant="primary" 
                            className={reembolsoAccion === 'aprobar' ? 'btn btn-success' : 'btn btn-danger'}
                            onClick={() => reembolsoAccion === 'aprobar' ? handleAprobarReembolso() : handleRechazarReembolso()}
                        >
                            {reembolsoAccion === 'aprobar' ? 'Aprobar' : 'Rechazar'}
                        </ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            <Modal show={showUploadDocumentoCoordinador} onHide={handleCloseUploadDocumentoCoordinador}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Cargar Documento de Coordinador</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Tipo de Documento *</Form.Label>
                                <Form.Select
                                    value={docTipoCoordinador}
                                    onChange={(e) => setDocTipoCoordinador(e.target.value)}
                                >
                                    <option value="">-- Selecciona un tipo de documento --</option>
                                    <option value="planilla">Planilla</option>
                                    <option value="comprobante">Comprobante</option>
                                    <option value="autorizacion">Autorización</option>
                                    <option value="comunicado">Comunicado</option>
                                    <option value="itinerario">Itinerario</option>
                                    <option value="reporte">Reporte</option>
                                    <option value="otro">Otro</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Archivo *</Form.Label>
                                <SingleFileUploadButton
                                    onFileUpload={handleFileUploadDocumentoCoordinador}
                                    type="pdf"
                                    acceptTypes={acceptTypesDocumentoCoordinador}
                                    maxSize="50"
                                />
                                {fileDocumentoCoordinador && (
                                    <p style={{ marginTop: '10px', color: '#4caf50' }}>
                                        <i className='material-icons' style={{ fontSize: '1rem', verticalAlign: 'middle', marginRight: '5px' }}>check</i>
                                        {fileDocumentoCoordinador.name}
                                    </p>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Descripción (Opcional)</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Agrega una descripción para este documento"
                                    value={docDescripcionCoordinador}
                                    onChange={(e) => setDocDescripcionCoordinador(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <ButtonComponent 
                            variant="secondary" 
                            className="btn btn-danger" 
                            onClick={handleCloseUploadDocumentoCoordinador}
                            disabled={loadingDocumentos}
                        >
                            Cancelar
                        </ButtonComponent>
                        <ButtonComponent 
                            variant="primary" 
                            className="btn btn-primary" 
                            onClick={handleCargarDocumentoCoordinador}
                            disabled={loadingDocumentos}
                        >
                            {loadingDocumentos ? 'Cargando...' : 'Cargar Documento'}
                        </ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            <ModalSeleccionarColumnasReporte 
                show={showModalSeleccionarColumnas} 
                onHide={() => setShowModalSeleccionarColumnas(false)} 
                onDescargar={handleDescargarReporteAlumnosColumnas} 
            />
        </div>
    )
}